import { render } from "./IncidentReportForm.vue?vue&type=template&id=7f56ed51&scoped=true"
import script from "./IncidentReportForm.vue?vue&type=script&lang=js"
export * from "./IncidentReportForm.vue?vue&type=script&lang=js"

import "./IncidentReportForm.vue?vue&type=style&index=0&id=7f56ed51&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7f56ed51"]])

export default __exports__